import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

const DeleteDiaologue = ({ msg, open, onClose, onConfirm, itemName }) => {
  // Helper to return action word based on msg type
  const getActionLabel = () => {
    if (msg === "cancel") return "cancel";
    if (msg === "reject") return "reject";

     if (msg === "close") return "close";
    return "delete";
  };

  const getActionButtonText = () => {
    if (msg === "cancel") return "Cancel";
    if (msg === "reject") return "Reject";
    if (msg === "close") return "Close";
    return "Delete";
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      BackdropProps={{
        style: { backgroundColor: "rgba(0, 0, 0, 0.2)" },
      }}
    >
      <DialogTitle>Confirm!!</DialogTitle>
      <IconButton
        aria-label="close"
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers>
        <DialogContentText>
          Are you sure you want to <strong>{getActionLabel()}</strong>{" "}
          {itemName ? <strong>{itemName}</strong> : "this item"}?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color="primary">
          Close
        </Button>
        <Button onClick={onConfirm} variant="contained" color="error" autoFocus>
          {getActionButtonText()}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteDiaologue;